/**
 * Copyright © 2025 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { styled } from '@mui/material/styles';
import { Box, Typography, Button, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import FingerprintIcon from '@mui/icons-material/Fingerprint';

export const DialogTitleContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
});

export const DialogContentContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '24px',
  padding: '16px 0',
});

export const IconWrapper = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

export const MessageText = styled(Typography)({
  fontSize: '14px',
  color: '#535353',
  textAlign: 'center',
  lineHeight: 1.5,
});

export const TitleText = styled(Typography)({
  fontSize: '18px',
  fontWeight: 600,
  color: '#000',
});

export const AlertWrapper = styled(Box)({
  width: '100%',
});

export const StyledFingerprintIcon = styled(FingerprintIcon)({
  fontSize: '48px',
  color: '#ff4c00',
});

export const StyledDialogTitle = styled(DialogTitle)({
  textAlign: 'center',
  paddingBottom: '8px',
});

export const StyledDialogContent = styled(DialogContent)({
  paddingLeft: '24px',
  paddingRight: '24px',
});

export const StyledDialogActions = styled(DialogActions)({
  paddingLeft: '24px',
  paddingRight: '24px',
  paddingBottom: '16px',
  paddingTop: '8px',
  justifyContent: 'center',
});

export const StyledIconContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  marginTop: '20px',
  marginBottom: '8px',
});

export const StyledCancelButton = styled(Button)({
  '&:hover': {
    backgroundColor: '#e0e0e0',
  },
  fontSize: '13px',
  textTransform: 'none',
  borderRadius: '8px',
  fontWeight: '600',
  color: '#395bbd',
});

export const StyledConfirmButton = styled(Button)({
  '&:hover': {
    backgroundColor: '#395bbd !important',
  },
  fontSize: '13px',
  textTransform: 'none',
  backgroundColor: '#395bbd',
  borderRadius: '8px',
  boxShadow: 'none !important',
  fontWeight: '600',
});
